const hasParentMeeting = (user) => {
  return user?.currentEvent?.sessions.some(session =>
    session?.groups?.some(group =>
      group.user_id === user.me.id
    )
  ) ?? false
}

export default hasParentMeeting